/**
 * Created by Rodrigo Quesada on 16/01/17.
 */
import {Injectable} from '@angular/core';
import {RepeatableScreensManagerDeps} from '../../../shared/step/repeatable-screen-manager.class';
import {OtherEducationService} from '../../../../domain/model/education/other/other-education.service';
import {RepeatableUserModelScreensManager} from '../../../../components/sections/repeatable/repeatable-user-model-screens-manager.service';

@Injectable()
export class OtherEducationScreensManager extends RepeatableUserModelScreensManager {

    constructor(rsmm: RepeatableScreensManagerDeps, protected readonly _modelService: OtherEducationService) {
        super(rsmm);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/education/steps/other/other-education-screens-manager.service.ts